<template>
  <div v-if="addingInvoice" class="invoice-link-selection">
    <BushelSelect
      v-model="invoice"
      :options="invoicesAvailable"
      track-by="uuid"
      label="name"
      no-deselect
      label-active="Invoice Link"
      :custom-label="customInvoiceLabel"
      :loading="loadingInvoices"
      :disabled="loadingInvoices"
      thin
      @select="selectInvoice"
    />
  </div>
</template>

<script>
import { dateShortestLocalized } from "@/services/filters";

export default {
  name: "ChatSelectInvoice",
  components: {},
  props: {
    invoiceSelected: { type: Object, default: null },
    invoicesAvailable: {
      type: Array,
      default() {
        return [];
      },
    },
    addingInvoice: { type: Boolean, default: false },
    invoicePresent: { type: Boolean, default: false },
    invoicesLoaded: { type: Boolean, default: false },
    loadingInvoices: { type: Boolean, default: false },
  },
  data() {
    return {
      invoice: null,
    };
  },
  computed: {},
  watch: {},
  created() {},
  mounted() {
    if (this.invoiceSelected) {
      this.invoice = this.invoiceSelected;
    }
  },
  beforeUnmount() {},
  updated() {},
  methods: {
    dateShortestLocalized,
    selectInvoice(selection) {
      this.invoice = selection;
      this.$emit("invoiceSelected", selection);
    },
    close() {
      this.$emit("close");
    },
    customInvoiceLabel({ name, order_data }) {
      if (order_data && order_data.order_date) {
        return `${name} - ${this.dateShortestLocalized(order_data.order_date)}`;
      }
      return `${name}`;
    },
  },
};
</script>

<style scoped></style>

<style lang="scss" scoped>
@import "@sass/_variables.scss";
.invoice-link-selection {
  border-radius: 5px;
  padding: 10px;
  background: $newChatMessageBgColor;
  border: 2px solid $newChatMessageBorderColor;
  &:after,
  &:before {
    top: 100%;
    left: 30px;
    border: solid transparent;
    content: "";
    height: 0;
    width: 0;
    position: absolute;
    pointer-events: none;
  }
  &:after {
    border-color: rgba(136, 183, 213, 0);
    border-top-color: $newChatMessageBgColor;
    border-width: 15px;
    margin-left: -15px;
  }
  &:before {
    border-color: rgba(194, 225, 245, 0);
    border-top-color: $newChatMessageBorderColor;
    border-width: 18px;
    margin-left: -18px;
  }
}
</style>
